import { EditCompanyInfoMutation } from "@/generated/graphql";
import { graphql, HttpResponse } from "msw";

export const editCompanyInfoHandler = graphql.mutation<EditCompanyInfoMutation>(
  "editCompanyInfo",
  ({ query, variables }) => {
    return HttpResponse.json({
      data: {
        editCompanyInfo: {
          result: true,
        },
      },
    });
  }
);
